import { BigNum, PublicKey } from '@drift-labs/sdk';

export const isNotionalDust = (val: BigNum) => {
	return !val.eqZero() && val.abs().toNum() < 0.01;
};

export const isValidPublicKey = (str: string): boolean => {
	try {
		new PublicKey(str);
		return true;
	} catch {
		return false;
	}
};
